// extracted by mini-css-extract-plugin
export default {"paper":"ResourceUtilizationInfoDialog_paper__PZNLo"};